import React from "react"
import {FormattedNumber} from "react-intl"
import {getNormalisedValue} from "../../currency/formatCurrency"

/** @author: Richard Scoones
 *  @desc: Disabling lint rule for "style" as react-intl (badly) use it for non style stuff
 */

/* eslint-disable react/style-prop-object */
export default ({isCents = true, value, ...props}) => {
  const normalisedValue = getNormalisedValue(isCents, props.currency, value).toFixed(2).replace(".00", "")
  return <FormattedNumber style="currency" {...props} value={normalisedValue} />
}
/* eslint-enable react/style-prop-object */
